import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./About.css";

import leftimg from "../../media/ceoimg.jpeg";
import TeamImage from "../../media/homeimg2.jpg";
import CEOImage from "../../media/ceoimg.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section className="about-main">
      <div className="container">
        <div className="row align-items-center gy-5">
          {/* LEFT CONTENT */}
          <motion.div
            className="col-lg-6 about-left"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 2 }}
          >
            <p className="about-subtitle text-uppercase text-primary fw-bold mb-2">
              About Our Company
            </p>
            <h2 className="about-title fw-bold mb-3">
              Inspiring Financial <br />
              Clarity & Growth
            </h2>
            <p className="about-text mb-4">
              RC Panta is an accomplished financial leader with a strong track
              record in public sector finance, higher education administration,
              and federal program management. He most recently served as
              Director of Auxiliary Finance at a major public university, where
              he was responsible for managing multimillion-dollar auxiliary
              budgets, overseeing complex fund accounting operations, and
              maintaining internal financial controls across diverse
              revenue-generating units.
            </p>

            <div className="d-flex flex-wrap align-items-center gap-4 mb-4 about-contact-block">
              <div className="d-flex align-items-center gap-2">
                <div className="about-icon-box">
                  <i className="bi bi-telephone fs-4 text-primary"></i>
                </div>
                <div>
                  <small className="text-uppercase text-muted d-block">
                    Call To Ask Any Query
                  </small>
                  <strong>720-412-7990</strong>
                </div>
              </div>

              <div className="about-divider"></div>

              <div className="d-flex align-items-center gap-2">
                <img
                  src={leftimg}
                  alt="RC Panta"
                  width="50"
                  height="50"
                  className="about-logo-div"
                />
                <div>
                  <small className="text-uppercase text-muted d-block">
                    Co-Founder & CEO
                  </small>
                  <strong>RC Panta</strong>
                </div>
              </div>
            </div>

            <Link to="/contact" className="btn btn-primary fw-bold hero-but">
              Contact Us <i className="bi bi-arrow-right"></i>
            </Link>
          </motion.div>

          {/* RIGHT IMAGES */}
          <div className="col-lg-6 about-right">
            <div className="row g-3 about-images-row">
              <div className="col-6 about-image-left">
                <img
                  src={leftimg}
                  alt="CEO"
                  className="img-fluid rounded-3 about-img dimmed-img"
                />
              </div>

              <div className="col-6 about-image-right d-flex flex-column">
                <div className="about-image-top mb-3 flex-fill">
                  <img
                    src={TeamImage}
                    alt="Team"
                    className="img-fluid rounded-3 about-img"
                  />
                </div>
                <div className="about-highlight-box text-white text-center rounded-3">
                  <h3 className="fw-bold mb-1">13+</h3>
                  <small className="text-uppercase">Years of Experiences</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
